import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import UnauthenticatedMessage from './UnauthenticatedMessage';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { userInfo, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  if (!userInfo?.is_authenticated) {
    return <UnauthenticatedMessage />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;